import { CELL_STATE_LABELS } from '@apps/web/features/coverage/model/coverage_types';
import {
    CELL_STATE_CLASSES,
    CELL_STATE_LEGEND_ORDER,
} from '@apps/web/features/coverage/ui/availability_cell_styles';
import { cn } from '@apps/web/lib/utils';

export function CoverageLegend() {
    return (
        <div
            className="flex flex-wrap items-center gap-x-4 gap-y-1"
            aria-label="Availability cell legend"
        >
            {CELL_STATE_LEGEND_ORDER.map((state) => (
                <span
                    key={state}
                    className="text-muted-foreground flex items-center gap-1.5 text-xs"
                >
                    <span
                        className={cn(
                            'h-3 w-5 rounded-sm',
                            CELL_STATE_CLASSES[state],
                        )}
                        aria-hidden="true"
                    />
                    {CELL_STATE_LABELS[state]}
                </span>
            ))}
        </div>
    );
}
